export const dataSelector = state => state.get('touchpoints').get('data');

export const detailsSelector = state => state.get('touchpoints').get('details');

export const visitsSelector = state => state.get('touchpoints').get('visits');
